<template>
  <div class="content_box">
    <div id="menuManage">
      <div class="leftTree">
        <el-tree
          node-key="id"
          ref="tree"
          :data="menuTree"
          :props="defaultProps"
          @node-click="handleNodeClick"
          default-expand-all
          v-loading="menuTreeLoading"
        ></el-tree>
      </div>
      <div class="rightCon contentPadding42" id="ManageTable">
        <div class="headTitle">
          <img src="@/assets/imgs/icon/icon_headIcon.png" alt />
          菜单管理
        </div>
        <el-form :inline="true" class="demo-form-inline">
          <el-form-item label="功能名称" style="margin-right: 30px">
            <el-input
              v-model.trim="searchObj.name"
              placeholder="请输入名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="是否菜单" style="margin-right: 30px">
            <el-select v-model="searchObj.menu" placeholder>
              <el-option label="不限" value></el-option>
              <el-option label="是" value="0"></el-option>
              <el-option label="否" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态：">
            <el-select v-model="searchObj.state" placeholder>
              <el-option label="不限" value></el-option>
              <el-option label="启用" value="0"></el-option>
              <el-option label="停用" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="onSearch"
              class="bg5584FF formBotton"
              style="margin-left: 40px"
              >查询</el-button
            >
            <el-button type="info" @click="onReset" class="formBotton"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
        <hr />
        <el-button type="primary" size="small" class="bg5584FF" @click="addNew">
          <i class="el-icon-plus"></i> 新增菜单
        </el-button>
        <div style="height: 20px"></div>
        <el-table
          v-loading="loading"
          :data="menuList"
          style="width: 100%"
          :header-cell-style="{ backgroundColor: '#DCDFE6', color: '#000' }"
        >
          <el-table-column align="center" prop="name" label="功能名称">
            <template slot-scope="scope">
              <span @click="detail(scope.row)" class="canClick">{{
                scope.row.name
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="shortName"
            label="功能显示简称"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="code"
            label="功能编码"
          ></el-table-column>
          <el-table-column align="center" prop="menu" label="是否菜单功能">
            <template slot-scope="scope">{{
              scope.row.menu == "0" ? "是" : "否"
            }}</template>
          </el-table-column>
          <el-table-column align="center" prop="superMenuObj" label="上级菜单">
            <template slot-scope="scope">{{
              scope.row.superMenuObj ? scope.row.superMenuObj.label : ""
            }}</template>
          </el-table-column>
          <el-table-column align="center" prop="state" label="状态">
            <template slot-scope="scope">{{
              scope.row.state == 0 ? "启用" : "停用"
            }}</template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="grade"
            label="顺序"
          ></el-table-column>
          <el-table-column align="center" label="操作" width="250">
            <template slot-scope="scope">
              <el-button
                size="mini"
                class="MR18 bg5584FF"
                type="primary"
                @click="editMenu(scope.row)"
                :disabled="scope.row.name == '菜单管理'"
                >编辑</el-button
              >
              <el-button
                size="mini"
                class="MR18 bg5584FF"
                type="primary"
                @click="deleteMenu(scope.row.id)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="pageBox">
          <!-- <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="10"
            layout="prev, pager, next, jumper"
            :total="totalNum"
          ></el-pagination> -->
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-size="10"
            layout="total,  prev, pager, next"
            :total="totalNum"
          >
          </el-pagination>
        </div>
      </div>
      <!-- 删除弹框 -->
      <el-dialog
        title="删除"
        :visible.sync="showDeleteWindow"
        class="delete"
        :close-on-click-modal="false"
      >
        <p>确认要删除该条数据？此操作不可逆</p>
        <div class="btnBox MT40">
          <el-button
            type="primary"
            size="mini"
            class="bg5584FF"
            @click="sureDelete"
            >确定</el-button
          >
          <el-button type="normal" size="mini" @click="showDeleteWindow = false"
            >取消</el-button
          >
        </div>
      </el-dialog>
      <!-- 查看弹框 -->
      <el-dialog
        title="查看"
        :visible.sync="showCheckWindow"
        class="dialog770 titleChange"
        :close-on-click-modal="false"
      >
        <el-form
          ref="checkForm"
          :model="checkObj"
          label-width="120px"
          size="small"
        >
          <el-row>
            <el-col span="12">
              <el-form-item label="上级菜单：">
                <el-input
                  v-model="checkObj.superMenuObj.label"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col span="12">
              <el-form-item label="功能名称：">
                <el-input v-model="checkObj.name" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col span="12">
              <el-form-item label="功能简称：">
                <el-input v-model="checkObj.shortName" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col span="12">
              <el-form-item label="功能编码：">
                <el-input v-model="checkObj.code" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col span="12">
              <el-form-item label="是否菜单功能：">
                <el-radio-group v-model="checkObj.menu" disabled>
                  <el-radio label="0">是</el-radio>
                  <el-radio label="1">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col span="12">
              <el-form-item label="移动端显示：">
                <el-radio-group v-model="checkObj.isPhone" disabled>
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="0">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col span="12">
              <el-form-item label="状态：">
                <el-radio-group v-model="checkObj.state" disabled>
                  <el-radio :label="0">启用</el-radio>
                  <el-radio :label="1">停用</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col span="12">
              <el-form-item label="显示顺序：">
                <el-input v-model="checkObj.grade" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col span="12">
              <el-form-item label="显示图标：">
                <el-input v-model="checkObj.logo" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col span="12">
              <el-form-item label="URL地址：">
                <el-input v-model="checkObj.menuUrl" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-dialog>
      <!-- 编辑弹框 -->
      <el-dialog
        title="编辑"
        :visible.sync="showEditWindow"
        class="dialog770 titleChange"
        :close-on-click-modal="false"
      >
        <el-form
          ref="editForm"
          :model="editObj"
          label-width="130px"
          size="small"
          v-loading="editLoading"
          :rules="editRules"
        >
          <el-row>
            <el-col span="12">
              <el-form-item label="上级菜单：" prop="superMenuObj">
                <el-cascader
                  :options="menuTree"
                  v-model="editObj.superMenuObj.value"
                  :props="props"
                  placeholder="请选择上级菜单"
                  change-on-select
                ></el-cascader>
              </el-form-item>
            </el-col>
            <el-col span="12">
              <el-form-item label="功能名称：" prop="name">
                <el-input v-model.trim="editObj.name"></el-input>
              </el-form-item>
            </el-col>
            <el-col span="12">
              <el-form-item label="功能简称：" prop="shortName">
                <el-input v-model.trim="editObj.shortName"></el-input>
              </el-form-item>
            </el-col>
            <el-col span="12">
              <el-form-item label="功能编码：" prop="code">
                <el-input v-model.trim="editObj.code" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col span="12">
              <el-form-item label="是否菜单功能：" prop="menu">
                <el-radio-group v-model="editObj.menu">
                  <el-radio label="0">是</el-radio>
                  <el-radio label="1">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col span="12">
              <el-form-item label="移动端显示：" prop="isPhone">
                <el-radio-group v-model="editObj.isPhone">
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="0">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col span="12">
              <el-form-item label="状态：" prop="state">
                <el-radio-group v-model="editObj.state">
                  <el-radio :label="0">启用</el-radio>
                  <el-radio :label="1">停用</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col span="12">
              <el-form-item label="显示顺序：" prop="grade">
                <el-input v-model.trim="editObj.grade"></el-input>
              </el-form-item>
            </el-col>
            <el-col span="12">
              <el-form-item label="显示图标：">
                <el-input v-model.trim="editObj.logo"></el-input>
              </el-form-item>
            </el-col>
            <el-col span="12">
              <el-form-item label="URL地址：">
                <el-input v-model.trim="editObj.menuUrl"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="btnBox">
          <el-button
            type="primary"
            size="mini"
            class="bg5584FF"
            @click="sureEdit"
            >保存</el-button
          >
          <el-button type="normal" size="mini" @click="showEditWindow = false"
            >取消</el-button
          >
        </div>
      </el-dialog>
      <!-- 新增弹框 -->
      <el-dialog
        title="新增菜单"
        :visible.sync="showAddWindow"
        class="dialog770 titleChange"
        :before-close="closeAdd"
        :close-on-click-modal="false"
      >
        <el-form
          ref="addForm"
          :model="addObj"
          label-width="130px"
          size="small"
          v-loading="addLoading"
          :rules="rules"
        >
          <el-row>
            <el-col span="12">
              <el-form-item label="上级菜单：" prop="superMenuObj">
                <el-cascader
                  :options="menuTree"
                  v-model="addObj.superMenuObj"
                  :props="props"
                  placeholder="请选择上级菜单"
                  change-on-select
                ></el-cascader>
              </el-form-item>
            </el-col>
            <el-col span="12">
              <el-form-item label="功能名称：" prop="name">
                <el-input v-model.trim="addObj.name"></el-input>
              </el-form-item>
            </el-col>
            <el-col span="12">
              <el-form-item label="功能简称：" prop="shortName">
                <el-input v-model.trim="addObj.shortName"></el-input>
              </el-form-item>
            </el-col>
            <el-col span="12">
              <el-form-item label="功能编码：" prop="code">
                <el-input v-model.trim="addObj.code"></el-input>
              </el-form-item>
            </el-col>
            <el-col span="12">
              <el-form-item label="是否菜单功能：" prop="menu">
                <el-radio-group v-model="addObj.menu">
                  <el-radio label="0">是</el-radio>
                  <el-radio label="1">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col span="12">
              <el-form-item label="移动端显示：" prop="isPhone">
                <el-radio-group v-model="addObj.isPhone">
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="0">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col span="12">
              <el-form-item label="状态：" prop="state">
                <el-radio-group v-model="addObj.state">
                  <el-radio :label="0">启用</el-radio>
                  <el-radio :label="1">停用</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col span="12">
              <el-form-item label="显示顺序：" prop="grade">
                <el-input v-model.trim="addObj.grade"></el-input>
              </el-form-item>
            </el-col>
            <el-col span="12">
              <el-form-item label="显示图标：">
                <el-input v-model.trim="addObj.logo"></el-input>
              </el-form-item>
            </el-col>
            <el-col span="12">
              <el-form-item label="URL地址：">
                <el-input v-model.trim="addObj.menuUrl"></el-input>
              </el-form-item>
            </el-col>
            <el-col span="12"></el-col>
          </el-row>

          <div class="btnBox">
            <el-button
              type="primary"
              size="mini"
              class="bg5584FF"
              @click="sureAdd"
              >新增</el-button
            >
            <el-button type="normal" size="mini" @click="closeAddBtn"
              >取消</el-button
            >
          </div>
        </el-form>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { Message } from "element-ui";
export default {
  data() {
    var checkNum = (rule, value, callback) => {
      if (!Number.isInteger(+value) || +value < 0) {
        callback(new Error("请输入正整数值"));
      } else {
        callback();
      }
    };
    var checkMenuName = (rule, value, callback) => {
      this.$axios
        .get(`/system/menu/searchMenuIsExisted/${value}`)
        .then((res) => {
          if (res.data == 0) {
            callback();
          } else {
            callback(new Error("功能名已存在"));
          }
        });
    };
    var checkMenuCode = (rule, value, callback) => {
      this.$axios
        .get(`/system/menu/searchMenuCodeIsExisted/${value}`)
        .then((res) => {
          if (res.data == 0) {
            callback();
          } else {
            callback(new Error("功能编码已存在"));
          }
        });
    };

    return {
      props: {
        value: "id",
        label: "title",
      },
      menuTree: [],
      defaultProps: {
        children: "children",
        label: "title",
      },
      searchObj: {
        name: "",
        menu: "",
        state: "",
      },
      menuList: [],
      checkObj: {
        superMenuObj: {
          label: "",
        },
        id: "",
        superMenu: "",
        name: "",
        shortName: "",
        code: "",
        menu: "",
        state: "",
        grade: "",
        logo: "",
        menuUrl: "",
        isPhone: "",
      },
      editObj: {
        id: "",
        superMenuObj: "",
        name: "",
        shortName: "",
        code: "",
        menu: "",
        state: "",
        grade: "",
        logo: "",
        menuUrl: "",
        superMenu: "",
        treeNodeId: "",
      },
      addObj: {
        superMenuObj: {},
        superMenu: "",
        treeNodeId: "",
        name: "",
        shortName: "",
        code: "",
        state: 0,
        menu: "0",
        grade: "",
        logo: "",
        menuUrl: "",
      },
      selectsuperMenu: [],
      deleteId: "",
      currentPage: 1,
      showDeleteWindow: false,
      showCheckWindow: false,
      showEditWindow: false,
      showAddWindow: false,
      loading: false,
      addLoading: false,
      menuTreeLoading: false,
      editLoading: false,
      totalNum: 0,
      pageObj: {},
      rules: {
        name: [
          { required: true, message: "请填写菜单名称", trigger: "blur" },
          { validator: checkMenuName, trigger: "blur" },
        ],
        shortName: [
          { required: true, message: "请填写菜单简称", trigger: "blur" },
        ],
        code: [
          { required: true, message: "请填写菜单编码", trigger: "blur" },
          { validator: checkMenuCode, trigger: "blur" },
        ],
        menu: [
          { required: true, message: "请选择是否菜单功能", trigger: "blur" },
        ],
        state: [{ required: true, message: "请选择状态", trigger: "blur" }],
        superMenuObj: [
          { required: true, message: "请选择上级菜单", trigger: "change" },
        ],
        grade: [
          { validator: checkNum, trigger: "blur" },
          { required: true, message: "请输入显示顺序", trigger: "blur" },
        ],
      },
      editRules: {
        name: [{ required: true, message: "请填写菜单名称", trigger: "blur" }],
        shortName: [
          { required: true, message: "请填写菜单简称", trigger: "blur" },
        ],
        code: [{ required: true, message: "请填写菜单编码", trigger: "blur" }],
        menu: [
          { required: true, message: "请选择是否菜单功能", trigger: "blur" },
        ],
        state: [{ required: true, message: "请选择状态", trigger: "blur" }],
        superMenuObj: [
          { required: true, message: "请选择上级菜单", trigger: "change" },
        ],
        grade: [
          { validator: checkNum, trigger: "blur" },
          { required: true, message: "请输入显示顺序", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    onSearch() {
      this.getMenuList({ pageNum: 1, pageSize: 10 }, this.searchObj);
    },
    onReset() {
      this.searchObj = {
        name: "",
        menu: "",
        state: "",
      };
      this.addObj = { state: 0, menu: "0" };
      this.getMenuList(
        { pageNum: 1, pageSize: 10 },
        { state: 0, menuId: "3d072a61118b461c9028e2546959ada9" }
      );
    },
    resetAddObj() {
      this.addObj = { state: 0, menu: "0" };
    },
    addNew() {
      this.showAddWindow = true;
    },
    closeAdd(done) {
      this.$refs.addForm.resetFields();
      this.resetAddObj();
      this.showAddWindow = false;
      done();
    },
    closeAddBtn() {
      this.$refs.addForm.resetFields();
      this.resetAddObj();
      this.showAddWindow = false;
    },
    sureAdd() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.addLoading = true;
          this.addObj.grade = parseInt(this.addObj.grade);
          this.addObj.superMenu = this.selectsuperMenu.filter(
            (res) =>
              res.value ==
              this.addObj.superMenuObj[this.addObj.superMenuObj.length - 1]
          )[0].label;
          this.addObj.treeNodeId = this.addObj.superMenuObj[
            this.addObj.superMenuObj.length - 1
          ];
          this.addObj.superMenuObj = {
            label: this.addObj.superMenu,
            value: this.addObj.treeNodeId,
          };
          this.$axios
            .post("/system/menu/insertMenuInfo", this.addObj)
            .then((res) => {
              Message.success("新增成功");
              this.addLoading = false;
              this.showAddWindow = false;
              this.onReset();
              this.getMenuTree();
              this.getLastMenu();
            })
            .catch((res) => {
              this.addLoading = false;
            });
        } else {
          Message.error("请完善表单信息");
          return false;
        }
      });
    },
    editMenu(row) {
      this.editObj = JSON.parse(JSON.stringify(row));
      this.showEditWindow = true;
    },
    sureEdit() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.editLoading = true;
          this.editObj.treeNodeId =
            this.editObj.superMenuObj.value instanceof Array
              ? this.editObj.superMenuObj.value[
                  this.editObj.superMenuObj.value.length - 1
                ]
              : this.editObj.superMenuObj.value;
          this.editObj.superMenu = this.selectsuperMenu.filter(
            (res) => res.value == this.editObj.treeNodeId
          )[0].label;
          console.log("编辑对象", this.editObj);
          this.$axios
            .put("/system/menu/updateMenuIfo", this.editObj)
            .then((res) => {
              Message.success("修改成功");
              this.editLoading = false;
              this.showEditWindow = false;
              this.onReset();
              this.getMenuTree();
              this.getLastMenu();
            })
            .catch((res) => {
              this.editLoading = false;
            });
        } else {
          Message.error("请完善表单信息");
          return false;
        }
      });
    },
    deleteMenu(id) {
      this.deleteId = id;
      this.showDeleteWindow = true;
    },
    sureDelete() {
      this.$axios
        .delete(`/system/menu/deleteMenuIfo/${this.deleteId}`)
        .then(() => {
          Message.success("删除成功");
          this.deleteId = "";
          this.showDeleteWindow = false;
          this.onReset();
          this.getMenuTree();
          this.getLastMenu();
        })
        .catch((res) => {
          this.deleteId = "";
          this.showDeleteWindow = false;
        });
    },
    detail(row) {
      console.log(row);
      this.checkObj = row;
      console.log(this.checkObj.isPhone);
      this.showCheckWindow = true;
    },
    handleSizeChange() {},
    handleCurrentChange(current) {
      this.getMenuList({ pageNum: current, pageSize: 10 }, this.pageObj);
    },
    handleNodeClick(obj, node) {
      this.getMenuList({ pageNum: 1, pageSize: 10 }, { menuId: node.key });
    },
    //获取菜单树
    getMenuTree() {
      this.menuTreeLoading = true;
      this.$axios
        .get("/system/menu/searchMenuTree", { params: "" })
        .then((res) => {
          this.menuTree = res.data;
          // this.$store.commit("setMenuTree", res.data);
          this.menuTreeLoading = false;
        })
        .catch((res) => {
          this.menuTreeLoading = false;
        });
    },
    //获取菜单列表
    getMenuList(pms, searchObj) {
      this.loading = true;
      var pmsObj = Object.assign(pms, searchObj);
      this.$axios
        .get("/system/menu/searchMenuPageList", {
          params: pmsObj,
        })
        .then((res) => {
          console.log("/////////", res);
          this.loading = false;
          this.menuList = res.data;
          this.totalNum = res.total;
          this.pageObj = searchObj;
        })
        .catch((res) => {
          this.loading = false;
        });
    },
    //获取上级菜单列表
    getLastMenu() {
      this.$axios
        .get("/system/menu/searchMenuNames")
        .then((res) => {
          this.selectsuperMenu = res.data;
        })
        .catch((res) => {
          this.loading = false;
        });
    },
  },
  created() {
    this.getMenuTree();
    this.onReset();
    this.getLastMenu();
  },
};
</script>

<style lang="less" scoped>
.content_box {
  padding: 20px 30px 30px;
}
@media (max-width: 1200px) {
  .content_box {
    padding: 20px 10px 30px;
  }
}
#menuManage {
  box-shadow: 0px 0px 50px #ccc;
  height: calc(90vh - 76px);
  display: flex;
  .leftTree {
    width: 260px;
    background-color: rgba(247, 248, 250, 1);
    box-sizing: border-box;
    padding: 20px 0px 20px 0px;
    height: 100%;
    overflow-y: auto;
  }
  .rightCon {
    width: calc(100% - 260px);
    height: 100%;
    overflow-y: auto;
    border-left: 1px solid rgb(220, 223, 230);
  }
  .el-cascader {
    width: 100%;
  }
}
#menuManage /deep/ .el-tree-node__children {
  .el-tree-node__label {
    padding: 2px 4px;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
  }

  .el-tree-node.is-current {
    background: rgba(247, 248, 250, 1);
    & > div:first-child .el-tree-node__label {
      background-color: #5584ff;
      color: #fff;
      box-shadow: 0px 2px 4px 0px #5584ff;
    }
  }
}
#menuManage .el-tree {
  background: rgba(247, 248, 250, 1);
}
.headTitle {
  font-size: 24px;
  font-weight: bold;
  color: rgba(68, 68, 68, 1);
  display: flex;
  align-items: center;
  margin-bottom: 30px;
  img {
    margin-right: 24px;
    padding-left: 2px;
  }
}
hr {
  border-color: rgba(155, 155, 155, 0.2);
  margin: 10px 0 20px;
}
#menuManage /deep/ .el-cascader-panel {
  width: 540px !important;
  overflow-x: scroll !important;
}
</style>